import React from 'react'

export const ErrorPage = () => {
    return (
        <div>
            <h1>
                Error 404! The page you are trying to access does not exist.
            </h1>
        </div>
    )
}
